import { atomWithStorage, createJSONStorage } from "jotai/utils"
import { z } from "zod"

export const addressSchema = z.object({
	address: z.string().min(1),
	latlon: z.tuple([z.number(), z.number()]),
})
export type AddressType = z.infer<typeof addressSchema>

const storage = createJSONStorage<AddressType>(() => localStorage)

export const defaultAddress: AddressType = {
	address: "",
	latlon: [0, 0],
}
export const hqAddressDraftAtom = atomWithStorage<AddressType>(
	"miles:draft:hq-address",
	defaultAddress,
	storage,
	{ getOnInit: true }
)
